module.exports = __webpack_public_path__ + "static/img/icon_taobao.59da8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_taobao.png
// module id = xVB6
// module chunks = 0